import { render, staticRenderFns } from "./CommunityProgress.vue?vue&type=template&id=2b56d3e4&scoped=true"
import script from "./CommunityProgress.vue?vue&type=script&lang=js"
export * from "./CommunityProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56d3e4",
  null
  
)

export default component.exports